module.exports = __webpack_public_path__ + "img/10.fe4b9eaf.svg";